import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#4b9ed6',
    secondary: '#6bc5ef',
    accent: '#202020',
    error: '#b71c1c'
  }
});
